import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";

import {
  danger,
  success,
  showLoading,
} from "../../../components/show-notification";

import api from "../../../providers/api";

import LoadingPanel from "../../../components/loading-painel";

import Layout from "../../../layout";

import validate from "./form-validate";

const LinkCadastrar = () => {
  const location = useLocation();
  const history = useHistory();

  const [state, setState] = useState({
    id: 0,
    titulo: "",
    descricao: "",
    titulo_in: "",
    descricao_in: "",
    titulo_es: "",
    descricao_es: "",
    imagem: "",
    url_android: "",
    url_ios: "",
  });

  let preencherValoresEdits = (event) => {
    setState({ ...state, [event.target.name]: event.target.value });
  };

  const enviarFormulario = async (e) => {
    e.preventDefault();

    if (!window.$("#form-link").valid()) {
      return;
    }

    try {
      const enviar = state.id > 0 ? api.put : api.post;

      const requisicao = await enviar("/links-uteis", state);

      const { data } = requisicao;

      if (!data.status) {
        danger(data.mensagem);
        return;
      }

      if (!data.data) {
        return;
      }

      success(data.mensagem);
      history.push("/link");
    } catch (error) {
      console.log(error);
      danger("Erro ao cadastrar o projeto.");
    }
  };

  const buscarDados = async (url) => {
    const requisicao = await api.get(`${url}`);

    const { data } = requisicao;

    if (!data.status) {
      danger(data.mensagem);
      return;
    }

    if (!data.data) {
      return;
    }

    return data.data;
  };

  const carregarDados = async () => {
    if (!location.state) {
      return;
    }

    return await buscarDados(`/links-uteis/${location.state.id}`);
  };

  useEffect(() => {
    const carregarTodosDados = async () => {
      try {
        showLoading(".ibox-content");

        const [link] = await Promise.all([carregarDados()]);

        if (link) {
          setState(link);
        }

        showLoading(".ibox-content");
      } catch (error) {
        console.log(error);
        showLoading(".ibox-content");
        danger("Erro ao carregar os dados do link");
      }
    };

    let validacao = window.$("#form-link").validate(validate);

    carregarTodosDados();

    return () => validacao.destroy();
  }, [location.state]);

  return (
    <>
      <Layout
        titulo="Ibraflex - Links Úteis"
        header="Cadastro do Link"
        action={{ titulo: "Voltar", link: "/link" }}
      >
        <div className="row">
          <div className="col-lg-12">
            <div className="ibox ">
              <div className="ibox-title">
                <h5>Dados do link</h5>
              </div>
              <div className="ibox-content">
                <LoadingPanel />
                <div className="row">
                  <div className="col-lg-12">
                    <form id="form-link">
                      <div className="row">
                        <div className="col-lg-12">
                          <div className="form-group">
                            <label>Imagem do link útil</label>
                            <input
                              type="text"
                              placeholder="Imagem do link útil"
                              className="form-control"
                              name="imagem"
                              value={state.imagem}
                              onChange={(e) => preencherValoresEdits(e)}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-lg-6">
                          <div className="form-group">
                            <label>Url android do link útil</label>
                            <input
                              type="text"
                              placeholder="Url android do link útil"
                              className="form-control"
                              name="url_android"
                              value={state.url_android}
                              onChange={(e) => preencherValoresEdits(e)}
                            />
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="form-group">
                            <label>Url ios do link útil</label>
                            <input
                              type="text"
                              placeholder="Url ios do link útil"
                              className="form-control"
                              name="url_ios"
                              value={state.url_ios}
                              onChange={(e) => preencherValoresEdits(e)}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-lg-12">
                          <div className="form-group">
                            <div class="tabs-container">
                              <ul class="nav nav-tabs" role="tablist">
                                <li>
                                  <a
                                    class="nav-link active"
                                    data-toggle="tab"
                                    href="#tab-1"
                                  >
                                    Português
                                  </a>
                                </li>
                                <li>
                                  <a
                                    class="nav-link"
                                    data-toggle="tab"
                                    href="#tab-2"
                                  >
                                    Inglês
                                  </a>
                                </li>
                                <li>
                                  <a
                                    class="nav-link"
                                    data-toggle="tab"
                                    href="#tab-3"
                                  >
                                    Espanhol
                                  </a>
                                </li>
                              </ul>
                              <div class="tab-content">
                                <div
                                  role="tabpanel"
                                  id="tab-1"
                                  class="tab-pane active"
                                >
                                  <div class="panel-body">
                                    <div className="row">
                                      <div className="col-lg-12">
                                        <div className="form-group">
                                          <label>Título do link útil</label>
                                          <input
                                            type="text"
                                            placeholder="Título do link útil"
                                            className="form-control"
                                            name="titulo"
                                            value={state.titulo}
                                            onChange={(e) =>
                                              preencherValoresEdits(e)
                                            }
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="row">
                                      <div className="col-lg-12">
                                        <div className="form-group">
                                          <label>Descrição do link útil</label>
                                          <textarea
                                            className="form-control"
                                            id="descricao"
                                            name="descricao"
                                            placeholder="Descrição do link útil"
                                            rows="5"
                                            value={state.descricao}
                                            onChange={(e) =>
                                              preencherValoresEdits(e)
                                            }
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  role="tabpanel"
                                  id="tab-2"
                                  class="tab-pane"
                                >
                                  <div class="panel-body">
                                    <div className="row">
                                      <div className="col-lg-12">
                                        <div className="form-group">
                                          <label>Título do link útil</label>
                                          <input
                                            type="text"
                                            placeholder="Título do link útil"
                                            className="form-control"
                                            name="titulo_in"
                                            value={state.titulo_in}
                                            onChange={(e) =>
                                              preencherValoresEdits(e)
                                            }
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="row">
                                      <div className="col-lg-12">
                                        <div className="form-group">
                                          <label>Descrição do link útil</label>
                                          <textarea
                                            className="form-control"
                                            id="descricao"
                                            name="descricao_in"
                                            placeholder="Descrição do link útil"
                                            rows="5"
                                            value={state.descricao_in}
                                            onChange={(e) =>
                                              preencherValoresEdits(e)
                                            }
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  role="tabpanel"
                                  id="tab-3"
                                  class="tab-pane"
                                >
                                  <div class="panel-body">
                                    <div className="row">
                                      <div className="col-lg-12">
                                        <div className="form-group">
                                          <label>Título do link útil</label>
                                          <input
                                            type="text"
                                            placeholder="Título do link útil"
                                            className="form-control"
                                            name="titulo_es"
                                            value={state.titulo_es}
                                            onChange={(e) =>
                                              preencherValoresEdits(e)
                                            }
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="row">
                                      <div className="col-lg-12">
                                        <div className="form-group">
                                          <label>Descrição do link útil</label>
                                          <textarea
                                            className="form-control"
                                            id="descricao"
                                            name="descricao_es"
                                            placeholder="Descrição do link útil"
                                            rows="5"
                                            value={state.descricao_es}
                                            onChange={(e) =>
                                              preencherValoresEdits(e)
                                            }
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div>
                        <button
                          className="btn btn-sm btn-success float-right m-t-n-xs"
                          type="submit"
                          onClick={(e) => enviarFormulario(e)}
                        >
                          <strong>Salvar</strong>
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Layout>
    </>
  );
};

export default LinkCadastrar;
